import { Link } from 'react-router-dom';

import { displayName } from '../shared/branding';
import { LumeMark } from '../shared/components/LumeMark';
import { useTranslation } from '../shared/i18n/useTranslation';

import { InstallPwaPrompt } from './InstallPwaPrompt';

export function Home() {
  const { t } = useTranslation();
  return (
    <main className="mx-auto flex min-h-screen max-w-2xl flex-col justify-center gap-6 p-6">
      <header className="flex flex-col items-start gap-3">
        <LumeMark size={72} title={displayName('user-facing')} />
        <p className="text-sm uppercase tracking-wide text-brand-700">{t('app.programLabel')}</p>
        <h1 className="flex flex-wrap items-baseline gap-x-3 text-4xl font-bold text-fg-DEFAULT">
          <span className="lowercase tracking-tight text-brand-900">
            {displayName('user-facing')}
          </span>
          <span className="text-2xl font-semibold text-fg-muted">— {t('home.title')}</span>
        </h1>
        <p className="text-lg text-fg-muted">{t('home.description')}</p>
      </header>
      <nav className="flex flex-wrap gap-3">
        <Link
          to="/login"
          className="inline-flex min-h-[48px] items-center justify-center rounded-lg bg-brand-800 px-5 font-medium text-fg-onBrand"
        >
          {t('home.cta.login')}
        </Link>
        <Link
          to="/signup"
          className="inline-flex min-h-[48px] items-center justify-center rounded-lg bg-brand-100 px-5 font-medium text-brand-900"
        >
          {t('home.cta.signup')}
        </Link>
      </nav>
      <InstallPwaPrompt variant="inline" />
      <footer className="mt-8 text-sm text-fg-subtle">{t('footer.brand')}</footer>
    </main>
  );
}
